import { methods, ServiceMaker } from "./index";

const { GET } = methods;

export const getCountryList = () => ServiceMaker(`/v2/all`, GET);
export const getLocationsAll = () => ServiceMaker(`/v2/locations?country_code=TH`, GET)

export const getLocationsIndia = () => ServiceMaker(`/v2/countries/india`, GET)
export const getLocationById = () => ServiceMaker(`/v2/locations?timelines=1`,GET)

